import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {type PayPalGateway} from './paypal';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {getLocaleText} from '../../util/translation';
import {type PayPalNamespace} from '@paypal/paypal-js';
import {PayPalCardPayment} from '../../../../native-checkout/ts/paypal/class-paypal-card-payment';
import {render} from '../../reducers/rootReducer';
import {store} from '../../store';
import cardBadgeURL from '../../../img/badge/card.svg';
import cardImageURL from '../../../img/marks/credit-card-regular.svg';

function initPayPalCardMethod(): PayPalGateway {
	let card: PayPalCardPayment | null = null;

	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.PAYPAL_CARD_GATEWAY, 'title') ?? 'Card',
		gatewayId: 'peachpay_paypal_card',
		description: paypalDescription(),
		assets: {
			title: {src: cardImageURL},
			badge: {src: cardBadgeURL},
		},
	};

	return {
		config,
		async activate(paypal: PayPalNamespace) {
			card = new PayPalCardPayment(paypal);
			if (!card.isEligible()) {
				card = null;
				config.initialized = false;
				store.dispatch(render());
				return;
			}

			card.mount();
		},
		submit(paymentAttempt) {
			if (!card) {
				console.error('PayPal card payment not initialized for submitting payment attempt');
				return;
			}

			card.submit(paymentAttempt);
		},
	};
}

function paypalDescription() {
	return `
	<div>
		<p style="text-align: left; margin: 0;">
			${getLocaleText('Pay securely using your credit or debit card.')}
		<p>
		<div id="pp-paypal-card-element" data-is-mounted="false">
			<div id="pp-paypal-card-name">
			</div>
			<div id="pp-paypal-card-number">
			</div>
			<div id="pp-paypal-card-expiry">
			</div>
			<div id="pp-paypal-card-cvv">
			</div>
		</div>
		<div id="pp-paypal-card-status" class="hide" style="display:flex;align-items:center;justify-content:center;gap:4px;">
			<i class="pp-icon-info"></i>
			<span></span>
		</div>
	</div>`;
}

export {
	initPayPalCardMethod,
};
